import React, { useState, useEffect, useContext } from "react";
import { HOST_URL, LOCAL_STORAGE_KEY } from "../../../../config";
import { StoreContext } from "../../../../store/Provider";
import { getUserData } from "../../../common/utility/Utils";
import ShipmentsCard from "./cardBody/ShipmentsCard";
import InfiniteScroll from "react-infinite-scroller";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { CircularProgress } from "@material-ui/core";
import axios from "axios";

function ShipmentSearchResults() {
  const [shipmentList, setShipmentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(true);
  const context = useContext(StoreContext);
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  useEffect(() => {
    if (
      context.advSearchFilter.tranportMode ||
      context.advSearchFilter.etd ||
      context.advSearchFilter.eta
    ) {
      getSearchResultByFilter(1);
    }
  }, [context.advSearchFilter]);
  useEffect(() => {
    if (context.searchInputValue) {
      getSearchResult(1);
    }
  }, [context.searchInputValue]);

  const getSearchResult = async (pageNumber) => {
    if (pageNumber === 1) {
      setShipmentList([]);
      setLoading(true);
    }
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const URL = `${HOST_URL}api/v2/ShipmentData/${data.user_country_code}/Search/${data.user_company_code}?page.cargoStatus=Search&page.pageNumber=${pageNumber}&page.pageSize=20`;
    const params = {
      ShipmentId: context.searchInputValue,
      TrasnportMode: "",
      Direction: "",
      ReferenceNumber: "",
      Status: "",
      LoadPort: "",
      DestinationPort: "",
      EastimatedArrival: "",
      EastimatedDeparture: "",
      FilterType: 1,
      JobDateCre: "",
      HouseBLNumber: "",
    };
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    axios
      .post(URL, params, {
        headers: header,
      })
      .then((res) => {
        let count = pageNumber + 1;
        let hasMorecheck = res.data.Data.length === 20 ? true : false;
        setHasMore(hasMorecheck);
        if (pageNumber === 1) {
          setShipmentList(res.data.Data);
        } else {
          setShipmentList([...shipmentList, ...res.data.Data]);
        }
        setLoading(false);
        setPageNumber(count);
        setLoadingMore(true);
      })
      .catch((err) => {
        console.log(err);
        setOpenalert(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const getSearchResultByFilter = async (pageNumber) => {
    if (pageNumber === 1) {
      setShipmentList([]);
      setLoading(true);
    }
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const URL = `${HOST_URL}api/v2/ShipmentData/${data.user_country_code}/Search/${data.user_company_code}?page.cargoStatus=Search&page.pageNumber=${pageNumber}&page.pageSize=20`;
    const params = {
      ShipmentId: "",
      TrasnportMode: context.advSearchFilter.tranportMode,
      Direction: "",
      ReferenceNumber: "",
      Status: "",
      LoadPort: "",
      DestinationPort: "",
      EastimatedArrival: context.advSearchFilter.eta,
      EastimatedDeparture: context.advSearchFilter.etd,
      FilterType: 1,
      JobDateCre: "",
      HouseBLNumber: "",
    };
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    axios
      .post(URL, params, {
        headers: header,
      })
      .then((res) => {
        let count = pageNumber + 1;
        let hasMorecheck = res.data.Data.length === 20 ? true : false;
        setHasMore(hasMorecheck);
        if (pageNumber === 1) {
          setShipmentList(res.data.Data);
        } else {
          setShipmentList([...shipmentList, ...res.data.Data]);
        }
        setLoading(false);
        setPageNumber(count);
        setLoadingMore(true);
      })
      .catch((err) => {
        console.log(err);
        setOpenalert(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const loadMore = () => {
    if (loadingMore) {
      if (
        context.advSearchFilter.tranportMode ||
        context.advSearchFilter.etd ||
        context.advSearchFilter.eta
      ) {
        getSearchResultByFilter(pageNumber);
      }
      if (context.searchInputValue) {
        getSearchResult(pageNumber);
      }

      setLoadingMore(false);
    }
  };

  if (loading) {
    return (
      <div className="loadingClass">
        <CircularProgress size="1.5rem" />
      </div>
    );
  }

  if (!loading && shipmentList.length === 0) {
    context.setRightHomeTitle(false);
    return (
      <div className="loadingClass" style={{ color: "#122d76" }}>
        No shipments found!!!
      </div>
    );
  }

  context.setRightHomeTitle(true);

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <div className="shipmentsCardsCol">
      <InfiniteScroll
        className="infiniteScroller"
        pageStart={0}
        loadMore={loadMore}
        hasMore={hasMore}
        loader={
          <div className="bottomLoader">
            <CircularProgress size="1.5rem" />
          </div>
        }
        useWindow={false}
      >
        {shipmentList.map((element) => {
          return (
            <ShipmentsCard key={element.ShipmentId} shipmentList={element} />
          );
        })}
      </InfiniteScroll>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default ShipmentSearchResults;
